import React from 'react'
import { Box } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

interface Props {
  reviewsCount: number
  currentIndex: number
}

function ReviewProgressLine(props: Props) {
  const { reviewsCount = 0, currentIndex = 0 } = props

  const { classes, cx } = useStyles()

  return (
    <Box className={classes.container}>
      {[...Array(reviewsCount).keys()].map((part) => {
        const isHighlighted = currentIndex === part
        return (
          <Box
            key={part}
            className={cx({
              [classes.part]: true,
              [classes.partHighlighted]: isHighlighted,
            })}
          />
        )
      })}
    </Box>
  )
}

export default ReviewProgressLine

const useStyles = makeStyles()((theme) => ({
  container: {
    display: 'flex',
    flex: 1,
    height: 3,
    background: '#e4e8f0',
    marginLeft: 150,
    flexDirection: 'row',
    [theme.breakpoints.down('md')]: {
      marginLeft: 'calc(3rem + 8px + 3rem + 20px)',
      marginRight: '6%',
      marginTop: '50px',
    },
    borderRadius: 5,
  },
  part: {
    flex: 1,
    height: 3,
  },
  partHighlighted: {
    background: theme.colors.blue[50],
    borderRadius: 5,
  },
}))
